const GIS_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

let gisPromise = null;

/*
 * Resolves to `google.accounts.id` from Google Identity Services.
 */
export function loadGoogleIdentity() {
  if (gisPromise) return gisPromise;

  gisPromise = new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) {
      resolve(window.google.accounts.id);
      return;
    }

    const script = document.createElement("script");
    script.src = GIS_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    const fail = (reason) => {
      gisPromise = null;
      script.remove();
      reject(new Error(reason));
    };
    script.onload = () => {
      if (window.google?.accounts?.id) {
        resolve(window.google.accounts.id);
      } else {
        fail("Google Identity Services did not initialize.");
      }
    };
    script.onerror = () => fail("Failed to load Google Identity Services.");
    document.head.appendChild(script);
  });

  return gisPromise;
}
